<script>
import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import debounce from 'lodash/debounce'

export default {
  components: {
    'mia-feature-input': FeatureInput
  },

  computed: {
    orderId() {
      return this.$store.state.service.filters.global.orderId
    }
  },

  methods: {
    onInput(orderId) {
      this.$store.commit('service/setGlobalOrderId', orderId)

      if (orderId.trim().length === 0) {
        this.$emit('change')
      } else {
        this.emitChangeDebounced()
      }
    },

    emitChangeDebounced: debounce(function () {
      this.$emit('change')
    }, 1000)
  }
}
</script>

<template>
  <mia-feature-input
    :value="orderId"
    label="Vorgangsnummer"
    type="text"
    @input="onInput"
  />
</template>
